import { css } from '@emotion/css';

export const selfieFrameCx = css``;
